module.exports = __webpack_public_path__ + "img/20240118touxiang.0dcbf29b.png";